export const applyCommonUserData = (state, payload = {}) => {
    state.userId = payload.userId ?? state.userId;
    state.name = payload.name ?? state.name;
    state.email = payload.email ?? state.email;
    state.isActive = payload.isActive ?? state.isActive;
    state.hasCredentials = payload.hasCredentials ?? state.hasCredentials;
    state.profilePhotoUrl = payload.profilePhotoUrl ?? state.profilePhotoUrl;
};

export const applyUserData = (state, payload = {}) => {
    state.userData.cafeId = payload.cafeId ?? state.userData.cafeId;
    state.userData.level = payload.level ?? state.userData.level;
    state.userData.totalExp = payload.totalExp ?? state.userData.totalExp;
    state.userData.kpiSchemeId = payload.kpiSchemeId ?? state.userData.kpiSchemeId;
    state.userData.checklistId = payload.checklistId ?? state.userData.checklistId;
};

export const applyAdminCafeList = (state, cafes = []) => {
    state.adminData.cafes = cafes;
    state.adminData.countOfCafes = cafes.length;
};
